

































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import contactsRepository from '@/services/contactsRepository';
import cPopup from '@/components/default/Popup.vue';

import Company from '@/classes/CRM/Company';
import Subcontractor from '@/classes/CRM/Subcontractor';

import CompanyDetailsDialog from '@/components/crm/company/CompanyDetailsDialog.vue';
import ContactDialog from '@/components/crm/ContactDialog.vue';

@Component({
  components: {
    cPopup,
    CompanyDetailsDialog,
    ContactDialog,
  },
})
export default class CreateContactDialog extends Vue {
  public show: boolean = false;
  private contact: any = null;

  private addContact() {
    const dialog = this.$refs.ContactDialog as ContactDialog;
    dialog.show = true;
    dialog.contactId = null;
    this.show = false;
  }

  private addCompany() {
    this.contact = new Company();
    (this.$refs.CompanyDetailsDialog as CompanyDetailsDialog).show = true;
    this.show = false;
  }

  private addSubcontractor() {
    this.contact = new Subcontractor();
    (this.$refs.CompanyDetailsDialog as CompanyDetailsDialog).show = true;
    this.show = false;
  }

  private updateEvent(e: any) {
    this.$emit('updated', e);
  }
}
